exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer[data-v-644a0ed9]{color:#5f6265;font-size:14px;display:flex;justify-content:space-between;align-items:center;padding-top:16px}[data-v-644a0ed9] .el-pagination{flex:1;display:flex;justify-content:flex-end;align-items:center}[data-v-644a0ed9] .el-pagination .el-pagination__sizes{flex:1}\n", ""]);

